// UPost.com - Payment Cancel Page
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardHeader, CardTitle, CardContent } from '../components/ui/card';
import { XCircle } from 'lucide-react';

export function PaymentCancel() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <Card className="max-w-md w-full">
        <CardHeader>
          <CardTitle className="flex items-center justify-center gap-2">
            <XCircle className="text-orange-600" size={32} />
            <span>Payment Cancelled</span>
          </CardTitle>
        </CardHeader>
        <CardContent className="text-center">
          <p className="mb-6">
            Your payment was cancelled. No charges have been made to your account.
          </p>
          
          <div className="space-y-3">
            <Button onClick={() => navigate('/upgrade')} className="w-full">
              Try Again
            </Button>
            <Button onClick={() => navigate('/dashboard')} variant="outline" className="w-full">
              Back to Dashboard
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}